export default __webpack_public_path__ + "static/media/imeichanger.c1ede180.png";